import { Section } from "../components/Section";
import BonusBanner from "../components/bonus/BonusBanner";

export default function Bonus() {
  return (
    <Section>
      <BonusBanner />
    </Section>
  );
}
